export const getTodaysDate = () => {

    const date = new Date();

    console.log(date.getFullYear() + '-' + (date.toLocaleDateString('default', { month: '2-digit' })) + '-' + date.toLocaleDateString('default', { day: '2-digit' }));
    return date.getFullYear() + '-' + (date.toLocaleDateString('default', { month: '2-digit' })) + '-' + date.toLocaleDateString('default', { day: '2-digit' });

  }

export  const formatDate = (dateString) => {
  const date = new Date(dateString);
  // Adjust the date to UTC
  date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
  const options = { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString(undefined, options);
};